var lightbox = new SimpleLightbox('.growl-component-lightbox-with-content__image', {});